<script setup>
import { ref } from 'vue';
import { update_report, get_file } from '@/services/child';
import { get_term } from '@/services/term';
import { swalError } from '@/helper';
const props = defineProps({
  reports: {
    type: Object,
    required: true
  }
})

const showSampleInput = ref(false)
const loading = ref(false)
async function submitReport(report){
  let response = await update_report(report)
  if (response.error){
    swalError(response.result.error)
    return
  }
  Swal.fire({
    title: 'Submitted',
    html: "Sample ID added",
    icon: 'success',
    // allowEscapeKey: false,
    // allowOutsideClick: false
  })
  report.attributes = {...response.result.data.data.attributes}
  report.attributes.status = await get_report_status_name(response.result.data.data.attributes.status)
  report.showSampleInput = false
  report.temp_sample_id = null
  report.sample_id = response.result.data.data.attributes.sample_id
}

async function get_report_status_name(report_status){
  let response = await get_term(report_status)
  if (response.error){
    Swal.fire({
      title: 'Error',
      html: response.result.error,
      icon: 'error',
      
    })
    return
  }
  return response.result.data.data.attributes.name
}

async function downloadFile(id = 0, file_name){
  if (!id || !file_name) return
  
  try {
    let response = await get_file(id)
    if (response.error) {
      swalError('Failed to fetch file')
      return
    }
    
    const fileUrl = response.result.data.data.attributes.document
    
    const fetchResponse = await fetch(fileUrl, {
      headers: {
        'Authorization': localStorage.getItem('uid')
      }
    })
    
    if (!fetchResponse.ok) throw new Error('Download failed')
    
    const blob = await fetchResponse.blob()
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = file_name
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Download error:', error)
    swalError('Failed to download file')
  }
}
</script>

<template>
  <div class="card">
    <div class="card-header card-no-border">
      <div class="header-top">
        <h5 class="m-0">Uploaded Report</h5>
      </div>
    </div>
    <div class="card-body pt-0" v-auto-animate>
      <template v-for="report in reports">
        <div class="child-report row align-items-center mb-4"
          :class="report.name == null ? 'unchecked' : 'checked'"
        >
          <div class="col-md-2 col-sm-2">
            <div class="check-btn">
              <vue-feather :type="report.name == null ? 'x' : 'check'" />
            </div>
          </div>
          <div class="col-md-10 col-sm-10 row px-0 download-content">
            <div class="col-md-6 col-sm-12 ps-0">
              <!-- Title -->
              <div class="row">
                <p class="mb-0 text-capitalize">{{ report.package_config.options?.name.value }}</p>
              </div>

              <!-- Add Sample ID -->
              <div class="row">
                <span v-if="report.sample_id == null || report.sample_id == '' ">
                  <button class="btn sample-id-btn badge-light-warning"
                    @click="report.showSampleInput = !report.showSampleInput"
                  >
                    Add New Sample ID
                  </button>
                </span>
                <p v-if="report.name !== null" class="f-light text-ellipsis">
                  {{ report.name }}
                </p>
              </div>

              <!-- Extra Info -->
              <div class="row">
                <p class="mb-0">
                  Status : 
                  <span class="fw-semibold">{{ report.attributes.status }}</span>
                </p>
                <!-- <p class="mb-0">
                  Extra Trait : 
                  <span class="fw-semibold">{{ report.attributes.extra_trait | 0 }}</span>
                </p> -->
              </div>
            </div>

            <!-- Action Button -->
            <div class="single-child-action col-md-6 col-sm-12 text-center ps-0">
              <button @click="downloadFile(report.id, report.name)" 
                :disabled="report.name == null ? true : false"
                class="btn badge-light-success"
              >
                <p>Download Report</p>
              </button>
              <p class="text-center d-flex justify-content-center f-light text-ellipsis mt-1">
                <span class="fw-medium">
                  Sample ID:
                </span> 
                <div class="ms-1">
                  <span v-if="report.sample_id == null || report.sample_id == '' ">
                    -
                  </span>
                  <span v-else>
                    {{ report.sample_id }}
                  </span>
                </div>
                <!-- <div class="d-flex ">
                </div> -->
              </p>
            </div>
          </div>
        </div>
        
        <!-- Sample ID Input -->
        <div v-if="report.showSampleInput" class="row">
          <div class="card shadow-none border">
            <form @submit.prevent="submitReport(report)" class="card-body row">
              <div class="col-md-12">
                <label class="form-label">Sample ID</label>
                <div class="row">
                  <div class="col-md-9">
                    <input class="form-control" type="text"
                      placeholder="123456789"
                      v-model="report.temp_sample_id"
                    >
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn btn-primary">
                      <span v-if="!loading">Submit</span>
                      <span v-else>
                        <div class="spinner-border spinner-border-sm" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </div>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
@media (max-width: 576px){
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .download-content{
    padding-left: 0.75rem !important;
  }
}
</style>